import React, { useEffect } from "react";
import GoogleMapReact from "google-map-react";
import { GOOGLE_API_KEY } from ".";

export default function Map({
  maps,
  map,
  markerCluster,
  locations,
  activeLocations,
  createMarkers,
  mapCircle,
  focusedLocation,
}) {
  const defaultMapProps = {
    center: {
      lat: 0,
      lng: 0,
    },
    zoom: 10,
  };

  const panToLocations = (items) => {
    let bounds = new maps.LatLngBounds();
    let zoom;

    if (
      (items && !Array.isArray(items)) ||
      (Array.isArray(items) && items.length === 1 && !mapCircle)
    ) {
      const item = Array.isArray(items) ? items[0] : items;
      bounds.extend(item.mapMarker.getPosition());
      zoom = 14;
    } else if (mapCircle) {
      bounds = mapCircle.getBounds();
    } else if (items.length) {
      // Reveal all active locations pins
      items.forEach((location) => {
        if (location.mapMarker) {
          bounds.extend(location.mapMarker.position);
        }
      });
    } else {
      // Reset bounds if there's nothing to pan to
      bounds = null;
    }

    if (bounds) {
      map.fitBounds(bounds);
      map.panToBounds(bounds);
      if (zoom) map.setZoom(zoom);
    }
  };

  useEffect(() => {
    if (maps && map && activeLocations) {
      // Remove all pins from the map
      locations.forEach((location) => {
        if (location.mapMarker) {
          location.mapMarker.setMap(null);
        }
      });

      // Reveil all active locations pins
      if (activeLocations.length) {
        activeLocations.forEach((location) => {
          if (location.mapMarker) {
            location.mapMarker.setMap(map);
          }
        });
      }

      if (markerCluster) {
        // Re-render marker clusterer
        markerCluster.clearMarkers(true);
        markerCluster.addMarkers(
          activeLocations.map((location) => location.mapMarker)
        );
      }

      panToLocations(activeLocations);
    }
  }, [activeLocations, mapCircle]);

  useEffect(() => {
    if (maps && map) {
      panToLocations(focusedLocation || activeLocations);
    }
  }, [focusedLocation]);

  return (
    <div className="locations-map">
      <GoogleMapReact
        bootstrapURLKeys={{
          key: GOOGLE_API_KEY,
          libraries: ["places", "geometry"],
        }}
        defaultCenter={defaultMapProps.center}
        defaultZoom={defaultMapProps.zoom}
        onGoogleApiLoaded={createMarkers}
      ></GoogleMapReact>
    </div>
  );
}
